import {isValidLengthDocumentId, sanitizeString} from "../../../../../Apis/functions";
import { IconDeviceConected, IconFingerprintCapture, IconWarningCapture } from "../../../../../components/buttons/IconButtons";

export const DEFAULT_TIME = new Date('2014-08-18T00:00:00');
export const ALL_TIME_TO = new Date('2014-08-18T23:59:59');
export const START_TIME = '00:00:00';
export const END_TIME = '23:59:59';
export const PIN_LENGTH = { MIN: 6, MAX: 6 };

/**
 * Validates that a PIN is not weak.
 * Rejects fully sequential values, ascending or descending (e.g. 123456 / 654321),
 * values containing a run of 3 or more identical digits (e.g. 000111 / 111111),
 * and values built from a repeating block (e.g. 121212 / 123123).
 * @param {string|number} value - The PIN to validate.
 * @returns {boolean} true if the PIN is strong enough, false if weak.
 */
export const isStrongPin = (value) => {
    const pin = String(value);
    if (!/^\d+$/.test(pin)) return false;

    // Reject 3 or more identical consecutive digits (e.g. 000111, 111111).
    if (/(\d)\1{2,}/.test(pin)) return false;

    // Reject any adjacent repeated 2-3 digit block (e.g. 1212 -> 121213, 123123, 121212).
    if (/(\d{2,3})\1/.test(pin)) return false;

    // Reject any run of SEQUENCE_THRESHOLD or more consecutive digits,
    // ascending or descending (e.g. 123456, 654321, 123455 -> 12345).
    const SEQUENCE_THRESHOLD = 3;
    let ascRun = 1;
    let descRun = 1;
    for (let i = 1; i < pin.length; i++) {
        const diff = pin.charCodeAt(i) - pin.charCodeAt(i - 1);
        ascRun = diff === 1 ? ascRun + 1 : 1;
        descRun = diff === -1 ? descRun + 1 : 1;
        if (ascRun >= SEQUENCE_THRESHOLD || descRun >= SEQUENCE_THRESHOLD) return false;
    }

    return true;
};
export const CECO_LENGTH = { MIN: 4, MAX: 256 };
export const CECO_CODE_NAME = "cecoCode";

export const USER_DATA = {
    id: '',
    userTypeId: '',
    name: '',
    lastName: '',
    secondLastName: '',
    genderId: '',
    phoneNumber: '',
    statusId: '',
    email: '',
    password: '',
    pin: '',
    documentId: '',
    dob: null,
    isValid: function (){
        return this.name !== '' &&
            this.lastName !== '' &&
            (!this.id || (this.id && this.email !== '' &&
            this.email != null))
    }
}


export const CONTRACTOR_EMPLOYEE_DATA = {
    ...USER_DATA,
    contractorEmployeeStatusId: '',
    contractorId: null,
    deviceId: null,
    firebaseId: null,
    selfie: null,
    userId: null,
    toCreateUpdate: function (password, extraData) {
        return {
            contractorEmployeeStatusId: this.contractorEmployeeStatusId !== '' ? this.contractorEmployeeStatusId : null,
            contractorId: sessionStorage.getItem('contractorId'),
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            selfie: this.selfie,
            userId: this.userId,
            documentId: this.documentId,
            password: password || null,
            extraData: extraData
            ? {
                field1: sanitizeString(extraData.field1),
                field2: sanitizeString(extraData.field2),
                field3: sanitizeString(extraData.field3),
                field4: sanitizeString(extraData.field4),
                field5: sanitizeString(extraData.field5),
                field6: sanitizeString(extraData.field6),
                field7: sanitizeString(extraData.field7),
                field8: sanitizeString(extraData.field8),
                field9: sanitizeString(extraData.field9),
                field10: sanitizeString(extraData.field10),
                field11: sanitizeString(extraData.field11),
                field12: sanitizeString(extraData.field12),
                field13: sanitizeString(extraData.field13),
                field14: sanitizeString(extraData.field14),
                field15: sanitizeString(extraData.field15),
                id: extraData.id,
                userId: extraData.userId,
            }
            : null
        };
    },
    isValidEmployee: function (){
        return  this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId &&
            isValidLengthDocumentId(this.documentId);
    }
}

export const TABS_SUPPLIER_EMPLOYEE = {
    DETAILS: {
        INDEX: 0
    },
    OTHER_DETAILS: {
        INDEX: 1
    },
    PHOTO: {
        INDEX: 2
    },
    SUMMARY: {
        INDEX: 3
    }
}

export const SUPPLIER_EMPLOYEE_DATA = {
    ...USER_DATA,
    supplierEmployeeStatusId: null,
    selfie: null,
    supplierId: null,
    userId: null,
    toRegister: function (password, extraData) {
        return {
            supplierEmployeeStatusId: this.supplierEmployeeStatusId !== '' ? this.supplierEmployeeStatusId : null,
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            supplierId: this.supplierId !== null ? null : sessionStorage.getItem('providerId'),
            userId: this.userId,
            documentId: this.documentId,
            password: password || null,
            extraData: extraData
            ? {
                field1: sanitizeString(extraData.field1),
                field2: sanitizeString(extraData.field2),
                field3: sanitizeString(extraData.field3),
                field4: sanitizeString(extraData.field4),
                field5: sanitizeString(extraData.field5),
                field6: sanitizeString(extraData.field6),
                field7: sanitizeString(extraData.field7),
                field8: sanitizeString(extraData.field8),
                field9: sanitizeString(extraData.field9),
                field10: sanitizeString(extraData.field10),
                field11: sanitizeString(extraData.field11),
                field12: sanitizeString(extraData.field12),
                field13: sanitizeString(extraData.field13),
                field14: sanitizeString(extraData.field14),
                field15: sanitizeString(extraData.field15),
                id: extraData.id,
                userId: extraData.userId,
            }
            : null
        };
    },
    isValidEmployee: function (){
        return  this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId &&
            isValidLengthDocumentId(this.documentId);
    }
}

export const EMPLOYEE_DATA = {
    departmentId: '',
    employeeId: '',
    startDate: null,
    endDate: null,
    roleId: '',
    zoneId: '',
    contractStatusId: '',
    id: '',
    [CECO_CODE_NAME]: null,
    hourlyRate: null,
    isValid: function (isPilgrimsValidation = false) {

        const validation =
            this.employeeId !== '' &&
            this.startDate !== null &&
            this.roleId !== '';

        if (isPilgrimsValidation) {
            return validation && (this.departmentId !== '' && this.departmentId !== null);
        }

        return validation;
    }
}

export const EXTRA_DATA = {
    field1: '',
    field2: '',
    field3: '',
    field4: '',
    field5: '',
    field6: '',
    field7: '',
    field8: '',
    field9: '',
    field10: '',
    field11: '',
    field12: '',
    field13: '',
    field14: '',
    field15: '',
}

export const HEADER_DATA = {
    header1: '',
    header2: '',
    header3: '',
    header4: '',
    header5: '',
    header6: '',
    header7: '',
    header8: '',
    header9: '',
    header10: '',
    header11: '',
    header12: '',
    header13: '',
    header14: '',
    header15: '',
}


export const CUSTOMIZED_MODEL = {
    fromValue: null,
    toValue: null,
    allDays: false,
    allTime: false,
    checkedZones: [],
    dayArray: [],
    isValid: function () {
        if (!this.checkedZones || this.checkedZones.length === 0) return false;
        if (!this.dayArray || this.dayArray.length === 0) return false;
        return !(this.fromValue === null || this.toValue === null);
    },
    clear: function (){
        return {
            ...this,
            checkedZones: [],
            dayArray: [],
            allTime: false,
            allDays: false,
            fromValue: DEFAULT_TIME,
            toValue: DEFAULT_TIME
        };
    }
};

export const SERVICE ={
    PILGRIMS:3
}
export const FingerprintStatus = {
  INITIAL: 'INITIAL',
  NO_DEVICE: 'NO_DEVICE',
  CONNECTED: 'CONNECTED',
  PUT_FINGER: 'PUT_FINGER',
  CAPTURING: 'CAPTURING',
  CAPTURED: 'CAPTURED',
  NO_DRIVER: 'NO_DRIVER',
};
export const FINGERPRINT_MODEL = {
  [FingerprintStatus.INITIAL]: {
    icon: <IconFingerprintCapture />,
    title: 'capture',
    subtitle: null,
    classes: {
      title: 'fs-16px font-color-shades-700 ibl-font-w-300',
      subtitle: '',
      icon: 'icon-color-shades-700',
    },
  },

  [FingerprintStatus.NO_DEVICE]: {
    icon: <IconWarningCapture />,
    title: 'no_device',
    subtitle: 'no_device_subtitle',
    classes: {
      title: 'fs-14px font-color-error-500 ibl-font-w-500',
      subtitle: 'fs-13px font-color-shades-700 ibl-font-w-300',
      icon: null,
    },
  },
  [FingerprintStatus.NO_DRIVER]: {
    icon: <IconWarningCapture />,
    title: 'no_driver',
    subtitle: 'no_driver_subtitle',
    classes: {
      title: 'fs-14px font-color-error-500 ibl-font-w-500',
      subtitle: 'fs-13px font-color-shades-700 ibl-font-w-300',
      icon: null,
    },
  },

  [FingerprintStatus.CONNECTED]: {
    icon: <IconDeviceConected />,
    title: 'device_connected',
    subtitle: 'device_connected_subtitle',
    classes: {
      title: 'fs-14px font-color-success-600 ibl-font-w-500',
      subtitle: 'fs-13px font-color-shades-700 ibl-font-w-300',
      icon: 'icon-color-success-500',
    },
  },

  [FingerprintStatus.PUT_FINGER]: {
    icon: <IconFingerprintCapture />,
    title: 'put_finger',
    subtitle: null,
    classes: {
      title: 'fs-16px font-color-shades-700 ibl-font-w-300',
      subtitle: null,
      icon: 'icon-color-shades-300',
    },
  },

  [FingerprintStatus.CAPTURING]: {
    icon: <IconFingerprintCapture />,
    title: 'capturing',
    subtitle: null,
    classes: {
      title: 'fs-20px font-color-secondary-500 ibl-font-w-500',
      subtitle: null,
      icon: 'icon-color-secondary-500',
    },
  },

 [FingerprintStatus.CAPTURED]: {
    icon: <IconFingerprintCapture />,
    title: 'captured',
    subtitle: null,
    classes: {
      title: 'fs-16px font-color-shades-700 ibl-font-w-300',
      subtitle: null,
      icon: 'icon-color-success-500',
    },
  },
};


export const CREATE_EMPLOYEE_WITH_EXTRA_DATA = {
    DETAILS: 0,
    OTHER_DETAILS: 1,
    EMPLOYEE_CONTRACT: 2,
    ACCESS_RIGHTS: 3,
    PHOTO_PROFILE: 4,
    FINGERPRINT: 5,
    CARD: 6,
    SUMMARY: 7,
};

export const CREATE_EMPLOYEE_WITHOUT_EXTRA_DATA = {
    DETAILS: 0,
    EMPLOYEE_CONTRACT: 1,
    ACCESS_RIGHTS: 2,
    PHOTO_PROFILE: 3,
    FINGERPRINT: 4,
    CARD: 5,
    SUMMARY: 6,
};

export const UPDATE_EMPLOYEE_WITH_EXTRA_DATA = {
    DETAILS: 0,
    OTHER_DETAILS: 1,
    EMPLOYEE_CONTRACT: 2,
    PHOTO_PROFILE: 3,
    CARD: 4,
    DOCUMENT_TABLE: 5,
    DRIVING_PERMITS: 6,
    ACCESS_RIGHTS: 7,
    FINGERPRINT: 8,
};

export const UPDATE_EMPLOYEE_WITHOUT_EXTRA_DATA = {
    DETAILS: 0,
    EMPLOYEE_CONTRACT: 1,
    PHOTO_PROFILE: 2,
    CARD: 3,
    DOCUMENT_TABLE: 4,
    DRIVING_PERMITS: 5,
    ACCESS_RIGHTS: 6,
    FINGERPRINT: 7,
};
export const FINGERPRINT_SOURCE_MODEL = {
    TEMP: 'temp',
    SERVER: 'server',
};
